var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "cursor",
      class: [
        { hover: _vm.isHovering },
        { wait: _vm.isWaiting },
        { inverted: _vm.isInverted },
      ],
      attrs: { id: "vue-cursor" },
    },
    [_c("div", { ref: "innerLoad", staticClass: "inner-load" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }